<template>
  <div id="app">
    <div id="topbar">
      <div class="container level is-mobile">
        <div class="level-left">
          <b-button v-if="loggedIn" icon-left="account-outline">
            {{ username }}
          </b-button>
          <b-button v-if="loggedIn" @click="openWallet()" class="ml-1" icon-left="wallet-outline">
            Wallet
          </b-button>
          <b-button v-if="!loggedIn" @click="openLogin()" icon-left="account-outline">
            Login
          </b-button>
          <b-button v-if="!loggedIn" class="ml-1" @click="openRegister()" icon-left="account-plus-outline">
            Register
          </b-button>
        </div>
        <div class="level-right logo">
          <img height="50" src="./assets/logo.svg" />
        </div>
      </div>
    </div>
    <RouterView :key="currentRoute" />
  </div>
</template>

<script>
import Wallet from "./components/Wallet.vue"
import Login from "./components/Login.vue"
import Register from "./components/Register.vue"
import { USER_INIT } from './store/User/action.type'
import { SET_CONNECTED } from './store/App/mutation.type'

export default {
  data() {
    return {}
  },
  mounted() {
    this.$store.dispatch(USER_INIT)
  },
  methods: {
    openWallet() {
      this.$buefy.modal.open({
        parent: this,
        component: Wallet,
        hasModalCard: true,
        trapFocus: true
      })
    },
    openLogin() {
      this.$buefy.modal.open({
        parent: this,
        component: Login,
        hasModalCard: true,
        trapFocus: true
      })
    },
    openRegister() {
      this.$buefy.modal.open({
        parent: this,
        component: Register,
        hasModalCard: true,
        trapFocus: true
      })
    }
  },
  computed: {
    currentRoute() {
      return this.$route.fullPath
    },
    username() {
      return this.$store.state.user.username
    },
    loggedIn() {
      return this.$store.state.user.loggedIn
    },
  },
  watch: {
    loggedIn(newVal, oldVal) {
      if (newVal) {
        this.$socket.io.engine.close()
        this.$store.commit('app/' + SET_CONNECTED, false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.level-right {
  img {
    max-height: 30px;
  }
}

@media only screen and (max-width: 600px) {
  .level-right > img {
    display: none;
  }
}
</style>
